/* eslint-disable */
const chunk = (arr: any, size: number): [][] =>
  arr.reduce(
    (acc: [], item: Object, idx: number) =>
      idx % size === 0 && arr.length !== idx + 1
        ? [...acc, [item]]
        : [...acc.slice(0, -1), [...acc.slice(-1)[0], item]],
    [],
  );

export default chunk;
